module.exports = __webpack_public_path__ + "img/load.9e879f2c.jpg";